"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALIDATE_STATUS_WARNING = exports.VALIDATE_STATUS_SUCCESS = exports.VALIDATE_STATUS_ERROR = exports.VALIDATE_ICONS = exports.INPUT_VARIANT = exports.DEFAULT_ICON_COLOR = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _VALIDATE_ICONS;

var DEFAULT_ICON_COLOR = 'greyDark';
exports.DEFAULT_ICON_COLOR = DEFAULT_ICON_COLOR;
var INPUT_VARIANT = {
  disabled: 'disabled',
  error: 'error',
  focused: 'focused'
};
exports.INPUT_VARIANT = INPUT_VARIANT;
var VALIDATE_STATUS_SUCCESS = 'success';
exports.VALIDATE_STATUS_SUCCESS = VALIDATE_STATUS_SUCCESS;
var VALIDATE_STATUS_ERROR = 'error';
exports.VALIDATE_STATUS_ERROR = VALIDATE_STATUS_ERROR;
var VALIDATE_STATUS_WARNING = 'warning';
exports.VALIDATE_STATUS_WARNING = VALIDATE_STATUS_WARNING;
var VALIDATE_ICONS = (_VALIDATE_ICONS = {}, (0, _defineProperty2.default)(_VALIDATE_ICONS, VALIDATE_STATUS_SUCCESS, {
  name: 'CheckIcon',
  color: 'tertiary'
}), (0, _defineProperty2.default)(_VALIDATE_ICONS, VALIDATE_STATUS_ERROR, {
  name: 'ErrorIcon',
  color: 'orange'
}), (0, _defineProperty2.default)(_VALIDATE_ICONS, VALIDATE_STATUS_WARNING, {
  name: 'ErrorIcon',
  color: 'yellow'
}), _VALIDATE_ICONS);
exports.VALIDATE_ICONS = VALIDATE_ICONS;